import requests from "./httpService";

const userServices = {
  // Get user info
  getUser() {
    return requests.get(`/user`);
  },
  getUserOrders() {
    return requests.get(`/user/orders`);
  },
  // Update user profile (name, phone)
  updateProfile(body) {
    return requests.put(`/user/profile`, body);
  },

  // Update existing address by index
  updateAddress(index, body) {
    return requests.put(`/user/address/${index}`, body);
  },

  // Add a new address
  addAddress(body) {
    return requests.post(`/user/address`, body);
  },

  // Remove address by index
  removeAddress(index) {
    return requests.delete(`/user/address/${index}`);
  },

  // Sync cart to database
  updateCart(cart) {
    const clean = JSON.parse(JSON.stringify(cart)); // deep clone
    return requests.post("/user/cart/update", { cart: clean });
  },

  // Sync wishlist to database
  updateWishlist(wishlist) {
    const clean = JSON.parse(JSON.stringify(wishlist));
    return requests.post("/user/wishlist/update", { wishlist: clean });
  },

  // ⭐ NEW: Get user orders
};

export default userServices;
